import { useQuery } from '@tanstack/react-query';

import { callGet } from '@/api/fetcher';
import {
  CartesiaDictionaryResponse,
  ElevenLabsDictionaryResponse,
} from '@/shared/types/integration';

const CARTESIA_DICTIONARY_ENDPOINT = '/www/api/v1/integrations/voice/cartesia/dictionaries';
const ELEVENLABS_DICTIONARY_ENDPOINT = '/www/api/v1/integrations/voice/elevenlabs/dictionaries';

const STALE_TIME = 5 * 60 * 1000;
const GC_TIME = 10 * 60 * 1000;

export const useCartesiaDictionary = (enabled = true) =>
  useQuery<CartesiaDictionaryResponse>({
    queryKey: [CARTESIA_DICTIONARY_ENDPOINT],
    queryFn: () => callGet(CARTESIA_DICTIONARY_ENDPOINT),
    staleTime: STALE_TIME,
    gcTime: GC_TIME,
    enabled,
  });

export const useElevenLabsDictionary = (enabled = true) =>
  useQuery<ElevenLabsDictionaryResponse>({
    queryKey: [ELEVENLABS_DICTIONARY_ENDPOINT],
    queryFn: () => callGet(ELEVENLABS_DICTIONARY_ENDPOINT),
    staleTime: STALE_TIME,
    gcTime: GC_TIME,
    enabled,
  });
